export default __webpack_public_path__ + "static/media/2_ru.543e10c3.png";